import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/backgroundLuckyWheel.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/backgroundLuckyWheelDesk.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/BG_GiroPremiado_MobH2.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/BG_GiroPremiadoH2.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/h2bWheel.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/h2premios.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/icatuLogo.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/logo-lideranca.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/lotepLogoWhite.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/sbtGold.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/assets/images/SbtPremiosLogo.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/brands/wep/images/backgroundLuckyWheel.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/brands/wep/images/backgroundLuckyWheelDesk.jpeg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/brands/wep/images/wep-branco.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/brands/wep/images/wepCenter.png");
;
import(/* webpackMode: "eager", webpackExports: ["Affiliate"] */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/components/Affiliate/Affiliate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FacebookPixel"] */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/components/Meta/FacebookPixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetaAttributionCookies"] */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/components/Meta/MetaAttributionCookies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AudioProviderWrapper"] */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/providers/AudioProviderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/ilotto-web-next/ilotto-web-next/src/providers/Providers.tsx");
